/**
 * Whether the signed-in viewer was invited to a job or RFP posting.
 *
 * An invitation is stored on the posting as `{ toUserId, invitedAt }`, where `toUserId` is the
 * invited party's main account: a candidate's own user, or for a company member the company's
 * main account, which every listing of that company names as its `adminId`.
 */

// The viewer's main account: the one their profile listing names, else their own user.
export const mainAccountUserIdOf = ({ currentUser, profileListing, mainUserId } = {}) =>
  mainUserId ||
  profileListing?.attributes?.publicData?.adminId ||
  currentUser?.attributes?.profile?.publicData?.adminId ||
  currentUser?.id?.uuid ||
  null;

export const isInvitedToPosting = (listing, viewer) => {
  const invited = listing?.attributes?.publicData?.invitedUsersToPosting;
  const mainAccountUserId = mainAccountUserIdOf(viewer);
  return (
    !!mainAccountUserId &&
    Array.isArray(invited) &&
    invited.some(entry => entry?.toUserId === mainAccountUserId)
  );
};
